<template>
  <div>
    <CookiePolicy />
    <Footer />
  </div>
</template>
